import { render, staticRenderFns } from "./intentionList.vue?vue&type=template&id=84d98438&"
import script from "./intentionList.vue?vue&type=script&lang=js&"
export * from "./intentionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d98438')) {
      api.createRecord('84d98438', component.options)
    } else {
      api.reload('84d98438', component.options)
    }
    module.hot.accept("./intentionList.vue?vue&type=template&id=84d98438&", function () {
      api.rerender('84d98438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tts/intentionList.vue"
export default component.exports